import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import simplebar from "simplebar-vue";
import EcGrid from "@/components/widgets/EcGrid.vue";
import assetAssessmentYearMachine from "./machines/assetDepreciationMachine";
import { interpret } from "xstate";
Component.registerHooks(["metaInfo"]);
let Depreciation = /** @class */ (() => {
    let Depreciation = class Depreciation extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Asset Depreciation";
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Depreciation",
                    active: true,
                },
            ];
            this.columns = [
                {
                    field: "formattedAssessmentYear",
                    label: "Assesment Year",
                    sortable: false,
                },
                {
                    field: "assetsAdded",
                    label: "Assets Added",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: false,
                    icon: "bx bx-info-circle",
                    iconTooltip: "No. of Assets includes all statuses.",
                },
                {
                    field: "totalAssetsInYear",
                    label: "Total Assets (Year)",
                    tdClass: "text-center",
                    thClass: "text-center",
                    sortable: false,
                    icon: "bx bx-info-circle",
                    iconTooltip: "No. of Assets with Instore, Assigned and Repair statuses",
                },
                {
                    field: "run",
                    label: "Run",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "formattedLastRunDate",
                    label: "Last Run Date",
                    tdClass: "text-center",
                    thClass: "text-center",
                    sortable: false,
                },
                {
                    field: "export",
                    label: "Export",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "loader",
                    label: "",
                    tdClass: "w-10",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                page: 1,
                sort: {
                    field: "startingDate",
                    type: "asc",
                },
                pageSize: 10,
            };
            this.totalCount = 0;
            this.machine = assetAssessmentYearMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({ type: "GETTING_ASSET_ASSESSMENT_YEAR", searchData: searchData });
        }
        onRowClick(params) { }
        RunDepreciationCalculation(assessmentYearId) {
            this.machineService.send({ type: "RUN_DEPRECIATION_CALCULATION", assessmentYearId: assessmentYearId });
        }
        Refresh() {
            this.loadItems();
        }
        tooltipContent(params) {
            return params.needsRerun && params.lastRunDate ? "Re-Run" : "Run";
        }
        GenerateAssetDepreciationReportAsExcel(assessmentYearId) {
            this.machineService.send({ type: "EXPORT_DEPRECIATION_EXCEL", assessmentYearId: assessmentYearId });
        }
        get isCalculationRunning() {
            return AssetMasterModule.assesmentYears.some((x) => x.isRunning == true);
        }
        get rows() {
            return AssetMasterModule.assesmentYears;
        }
        get totalCountAsset() {
            return AssetMasterModule.totalAssesmentYearCount;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("loadedAssetAssessmentYears")) {
                    this.totalCount = this.totalCountAsset;
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Depreciation = __decorate([
        Component({
            name: "AssetDepreciation",
            components: {
                Loader,
                Layout,
                PageHeader,
                SectionLoader,
                simplebar,
                EcGrid,
            },
        })
    ], Depreciation);
    return Depreciation;
})();
export default Depreciation;
